namespace $ { $mol_style_attach( "mol/chat/demo/demo.view.css",
 "[mol_chat_demo_pages] {\n\tflex: 1 1 auto;\n}\n"
) }